import React, { Component } from 'react';

import Dialog from '../../../raven/modals/dialog';
import TombstoneView from './tombstoneView';

import CognitoUtil from '../../../../aws/cognito/cognitoUtil';
import moment from 'moment';

export default class TombstoneHistoryModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            tombstones: []
        };
    }

    loadMoreData = () => 
    {
        let mindate = moment(this.state.tombstones[0].ts).unix();
        let maxdate = moment(this.state.tombstones[this.state.tombstones.length - 1].ts).unix();
        console.debug("Load more data requested", mindate < maxdate ? mindate : maxdate);
        
        this.getRavenTombstones(mindate < maxdate ? mindate : maxdate);
    }

    queryServer = (url, callback) => {
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + CognitoUtil.getCurrentUserToken()
            }
        })
        .then(response => response.json())
        .then(data => {
            console.debug("Fetched data:", data);
            callback(data);
        })
        .catch(error => {
            console.error("Error fetching data:", error);
            callback([]);
        });
    }

    getRavenTombstones = (date) => {

        // perform ajax calls to get it the next state
        var url = "" + this.props.dataStore.prefix1 + "logs"
                + "?stage=" + this.props.stage
                + "&type=tombstones"
                + "&raven=" + this.props.raven.raven_id
                + "&uuid=" + this.props.raven.raven_uuid
                + "&version=" + this.props.raven.raven_os;

        if(date)
            url += '&end=' + date;

        this.queryServer(url, (data) => {
            if (data && data.length > 0) {
                this.setState({
                    tombstones: data,
                    loading: false
                });
            } else {
                this.setState({
                    tombstones: [],
                    loading: false
                });
            }
        });
    }
    componentDidMount() {
        this.getRavenTombstones();
    }

    render() {

        return (
            <Dialog
                size="medium"
                className="test"
                label={this.props.title}
                isOpen={this.props.isOpen}
                onClose={this.props.onClose}
                >
                    <div>
                        <div className="row">
                            <div className="col-12">
                                {
                                    this.state.tombstones && !this.state.loading ?
                                        this.state.tombstones.length !== 0 ?  
                                            <TombstoneView 
                                                data={this.state.tombstones} 
                                                loading={false}
                                                requestMoreData={this.loadMoreData}
                                                /> : 
                                            <p>No Tombstone Data...</p> :
                                        <p>Loading...</p>
                                }
                            </div>
                        </div>
                    </div>
            </Dialog>
        );
    }
}
